import List from '@utils/list'
const { Jurisdiction, Table } = List

const jurisdiction = new Jurisdiction()
  .lib('add').to('Performance.QualitativeProject.Add')
  .lib('modify').modify('Performance.QualitativeProject.Modify')
  .lib('delete').del('/srmQualitativeItem/deleteSrmQualitativeItemByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('performance.qualitativeProject')
  .add('qualitativeItemNo')
  .add('qualitativeItemName')
  .add('deptId').name('deptName')
  .add('remarks')

export default new List()
  .url('/srmQualitativeItem/getSrmQualitativeItemPageByParams', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .table(table)
  .end()
